import React, {Suspense, Profiler} from "react";
import {Redirect, Switch} from "react-router-dom";
import {useSelector} from "react-redux";

import {LayoutSplashScreen, ContentRoute} from "../_metronic/layout";
import Dashboard from "./pages/Dashboard";
import {ErrorPage1} from "./pages/ErrorPage/ErrorPage1";
import {checkPermission} from "../app/redux_slices/contextSlice";

const BasePage = props => {
    const {docTitle} = props;
    const canUploadVideos = useSelector(state => checkPermission(state, `settings.viewMenuLink`));

    return (
        <Profiler id="Panel" onRender={() => {}}>
            <Suspense fallback={<LayoutSplashScreen />}>
                <Switch>
                    {/* Redirect from root URL to /tracks. */}
                    <Redirect exact from="/" to="/homepage" />
                    <ContentRoute
                        exact
                        docTitle={docTitle}
                        pageTitle="Home Page"
                        path="/homepage"
                        render={props => <Dashboard page="homepage" {...props} />}
                    />
                    <ContentRoute
                        exact
                        docTitle={docTitle}
                        pageTitle="Track - Explore"
                        path="/track/:level_id"
                        render={props => <Dashboard page="trackPage" {...props} />}
                    />
                    <ContentRoute
                        docTitle={docTitle}
                        pageTitle="Media item"
                        path="/media/:videoId"
                        render={props => <Dashboard page="media" {...props} />}
                    />
                    <ContentRoute
                        docTitle={docTitle}
                        pageTitle="Video Review"
                        path="/review/:videoId?"
                        render={props => <Dashboard page="review" {...props} />}
                    />
                    <ContentRoute
                        docTitle={docTitle}
                        pageTitle="Profile"
                        path="/profile"
                        render={props => <Dashboard page="profile" {...props} />}
                    />
                    {canUploadVideos ? (
                        <ContentRoute
                            docTitle={docTitle}
                            pageTitle="Settings"
                            path="/adminpanel"
                            render={props => <Dashboard page="settings" {...props} />}
                        />
                    ) : null}
                    <ContentRoute
                        exact
                        docTitle={docTitle}
                        pageTitle="Error 404"
                        render={props => <ErrorPage1 {...props} />}
                    />
                </Switch>
            </Suspense>
        </Profiler>
    );
};

export default BasePage;
